import { ReduxStore } from 'store/types';

function changeStatusIsLoading(state: ReduxStore): boolean {
  return state.product.changeStatus.config.isLoading;
}

export default changeStatusIsLoading;
